// extracted by mini-css-extract-plugin
export default {"page-title-header":"about_page-title-header__OwMBR","description-text":"about_description-text__PiPIA"};